import { GET_ACCESSORIES } from "../graphql-saleor/queries/getAccessoryQuery"
import { useQuery } from "@apollo/client"
import { client } from "../graphql-saleor/client"
import { Product } from "../components/interfaces/SaleorTypes"
import { SELECTED_CHANNEL_SLUG, CATEGORY_ACCESSORIES_SLUG } from "../utils/saleor-constants"

interface GetAccessoriesData {
  category: {
    products: {
      edges: {
        node: Product
      }[]
    }
  }
}

interface GetAccessoriesVars {
  channelSlug: string
  categorySlug: string
}

export const useGetAccessoryQuery = () => {
  const { data, error, loading, refetch } = useQuery<GetAccessoriesData, GetAccessoriesVars>(GET_ACCESSORIES, {
    client: client,
    variables: {
      channelSlug: SELECTED_CHANNEL_SLUG,
      categorySlug: CATEGORY_ACCESSORIES_SLUG,
    },
  })

  return {
    accessories: data?.category?.products?.edges?.map((edge) => edge.node) as Product[] | undefined,
    error,
    loading,
    refetch,
  }
}
